import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  Typography,
} from "@material-ui/core";
import { AppBarButton } from "@ofqual/portal-components/components/SecondaryAppBar";
import React, { useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { Error } from "../common/Error";
import { TextField } from "@ofqual/portal-components/components/TextField";
import { rejectQualification } from "../../redux/actions";
import { Qualification } from "../../domain/Qualification";

type RejectButtonAndDialogProps = {
  item: Qualification;
};

export const RejectButtonAndDialog: React.FC<RejectButtonAndDialogProps> = (
  props
) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <AppBarButton text="Reject" data-test="reject-button" onClick={() => setIsOpen(true)} />
      {isOpen && <RejectDialog {...props} onClose={() => setIsOpen(false)} />}
    </>
  );
};

type RejectDialogProps = {
  item: Qualification;
  onClose: () => void;
};

const RejectDialog: React.FC<RejectDialogProps> = ({ item, onClose }) => {
  const dispatch = useDispatch();
  const { control, errors, handleSubmit } = useForm({
    defaultValues: { response: "" },
  });

  const onSubmit = (model: { response: string }) => {
    dispatch(rejectQualification(item.id, model.response));
    onClose();
  };

  return (
    <>
      <Dialog open={true} onClose={onClose} maxWidth="md" fullWidth>
        <DialogTitle>Reject Qualification</DialogTitle>
        <Divider component="div" />
        <DialogContent>
          <form>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Typography variant="body1">
                  Please complete the following fields and confirm you wish to
                  reject this qualification
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Controller
                  control={control}
                  name="response"
                  rules={{ required: true }}
                  as={
                    <TextField
                      label="Response"
                      data-test="response"
                      required
                      multiline
                      rows={5}
                    />
                  }
                />
                {errors.response && <Error>This field is required</Error>}
              </Grid>
            </Grid>
          </form>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} data-test="reject-cancel-button"color="primary">
            Cancel
          </Button>
          <Button onClick={handleSubmit(onSubmit)} data-test="reject-confirm-button" color="primary">
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
